import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = ["src", "muted", "type"]

import { computed, h, onMounted, ref, watch } from "vue";
import { ElLoading } from "element-plus";
import { AuthStatus } from "@/types/router";
import Info from "@/components/Loading/Info.vue";
import { AuthModule } from "@/store/modules/Auth";
import { AppModule, Audios } from "./store/modules/app";
import { OutputDeviceModule } from "./store/modules/OutputDevice";

// Variables

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingStatuses = [AuthStatus.LOADING_CALL, AuthStatus.LOADING_CHAT];
const audiosRefs = ref<
	(HTMLAudioElement & { setSinkId: (param: any) => Promise<void> })[]
>([]);

// computed
const configOmnichannel = computed(() =>
	AppModule.configs?.find(c => c.name === "omnichannel_config")
);
let loadingService: ReturnType<typeof ElLoading["service"]>;

watch(
	() => AuthModule.status,
	(status, prevStatus) => {
		if (
			loadingStatuses.includes(prevStatus) &&
			!loadingStatuses.includes(status)
		)
			!!loadingService && loadingService.close();
		else if (
			!loadingStatuses.includes(prevStatus) &&
			loadingStatuses.includes(status)
		)
			loadingService = ElLoading.service({
				lock: true,
				// eslint-disable-next-line
				text: h(Info) as any,
				background: "rgba(0,0,0,.7)",
			});
	}
);

function setAudiosRefs(el: any) {
	if (el) audiosRefs.value.push(el);
}

onMounted(() => {
	const ringtoneDeviceId = OutputDeviceModule.RingtoneOutputDevice;
	const ringtoneVolume = OutputDeviceModule.ringtoneOutputDeviceVolume;

	if (ringtoneDeviceId)
		audiosRefs.value.forEach(audioRef => {
			audioRef
				.setSinkId(ringtoneDeviceId)
				.then(() => {
					console.log(
						"Se configuro el dispositivo de salida correctamente",
						OutputDeviceModule.RingtoneOutputDeviceName
					);
				})
				.catch(() => {
					console.log(
						"No se ha configurado el dispositivo de salida correctamente"
					);
				});
			audioRef.volume = ringtoneVolume ? ringtoneVolume / 100 : 1;
		});
	AppModule.setNotificationElement(audiosRefs.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(Audios)), ([key, src], index) => {
      return (_openBlock(), _createElementBlock("audio", {
        ref_for: true,
        ref: setAudiosRefs,
        key: index,
        src: src,
        muted: (_unref(configOmnichannel)?.data[0] as any)?.[`AUDIO_${key}`] === 'off',
        type: index < 2 ? 'audio/mp3' : 'audio/wav'
      }, null, 8, _hoisted_1))
    }), 128)),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fadeUp",
          "leave-active-class": "fadeOutDown"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ], 64))
}
}

})